export class SearchObserver {

  constructor(termo) {
    this.termo = termo
    this.searchResults = document.querySelector('#autocomplete-results')
    this.searchResultsItensContainer = document.querySelector('.autocomplete-results-itens');
    this.searchResultsItens = document.querySelectorAll('.autocomplete-results-itens__item')
  }

  next(res) {
    this.searchResults.innerHTML = ''
    if (res.data.sugestoes.length)
      this.buildResults(res.data)
    else
      this.noResults()
  }

  error(error) {
    this.noResults()
  }

  complete() {}

  buildResults(results) {
    if(results.sugestoes) {
      const sugestoes = results.sugestoes;
      for (let i = 0; i < sugestoes.length; i++) {
        let str = sugestoes[i].label;
        if(str.length > 42) str = str.substring(0,42);
        let item = document.createElement('li')
        item.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0V0z"/><path d="M15.5 14h-.79l-.28-.27c1.2-1.4 1.82-3.31 1.48-5.34-.47-2.78-2.79-5-5.59-5.34-4.23-.52-7.79 3.04-7.27 7.27.34 2.8 2.56 5.12 5.34 5.59 2.03.34 3.94-.28 5.34-1.48l.27.28v.79l4.25 4.25c.41.41 1.08.41 1.49 0 .41-.41.41-1.08 0-1.49L15.5 14zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/></svg><a href="/panvel/buscarProduto.do?termoPesquisa=${sugestoes[i].label}" title="${sugestoes[i].label}"><span>${str}</span></a>`
        this.searchResults.appendChild(item)
      }
      this.highlightSearch(this.termo)
    }

    if(results.produtos && results.produtos.length > 0) {
      const lis = this.searchResultsItensContainer.querySelectorAll("li");

      for (let i = 0; i < lis.length; i++) {
        const item = lis[i];
        if(!item.classList.contains("autocomplete-results-itens__item"))
          this.searchResultsItensContainer.removeChild(item)
      }

      for (let i = 0; i < this.searchResultsItens.length; i++) {
        const item = this.searchResultsItens[i];
        item.style.display = "none"
      }

      for (let i = 0; i < results.produtos.length; i++) {
        const item = results.produtos[i];
        this.searchResultsItensContainer.appendChild(this.buildItem(item))
      }
    }
  }

  noResults() {
    this.searchResults.innerHTML = `<li class="no-results">Nenhum resultado encontrado.</li>`
  }

  highlightSearch(str) {
    let searchResults = this.searchResults.querySelectorAll('li')

    for (let i = 0; i < searchResults.length; i++) {
      const elem = searchResults[i];
      let span = elem.querySelector('a > span')
      let resultText = span.innerText
      let reg = new RegExp('\\b('+ str + ')', 'gmi')
      span.innerHTML = resultText.replace(reg, '<b>$1</b>')
    }
  }

  buildItem(produto) {
    let item = document.createElement('li')
    item.innerHTML = `<div class="autocomplete-item"><div class="autocomplete-item__img"><img src="${produto.imagem.replace(new RegExp('ims=40x', 'g'), 'ims=150x')}" alt="${produto.label}" onerror="this.onerror=null;this.src='https://cdn1.staticpanvel.com.br/produtos/15/default.jpg?ims=150x';"></div><div class="autocomplete-item__info"><span class="autocomplete-item__nome"><a href="${produto.url}">${produto.label}</a></span><span class="autocomplete-item__preco">${(produto.retencao_receita) ? '' : produto.preco_por}</span></div></div>`;

    return item;
  }

}



// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/search/search.observer.js